import { render } from "./CompanyProductProfile.vue?vue&type=template&id=53bd3d4a&scoped=true"
import script from "./CompanyProductProfile.vue?vue&type=script&lang=js"
export * from "./CompanyProductProfile.vue?vue&type=script&lang=js"

import "./CompanyProductProfile.vue?vue&type=style&index=0&id=53bd3d4a&scoped=true&lang=css"
import "./CompanyProductProfile.vue?vue&type=style&index=1&id=53bd3d4a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53bd3d4a"]])

export default __exports__